import React from 'react';

interface AlertProps {
  children: React.ReactNode;
  variant?: 'error' | 'warning' | 'info' | 'success';
}

export function Alert({ children, variant = 'error' }: AlertProps) {
  const colorMap: Record<string, { bg: string; text: string; border: string }> = {
    error: {
      bg: 'rgba(255, 60, 172, 0.1)',
      text: 'var(--color-danger)',
      border: 'var(--color-danger)',
    },
    warning: {
      bg: 'rgba(255, 138, 61, 0.1)',
      text: 'var(--color-warning)',
      border: 'var(--color-warning)',
    },
    info: {
      bg: 'rgba(45, 226, 230, 0.1)',
      text: 'var(--color-info)',
      border: 'var(--color-info)',
    },
    success: {
      bg: 'rgba(182, 255, 60, 0.1)',
      text: 'var(--color-success)',
      border: 'var(--color-success)',
    },
  };

  const colors = colorMap[variant];

  return (
    <div
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        borderLeft: `3px solid ${colors.border}`,
        padding: 'var(--space-3) var(--space-4)',
        borderRadius: 'var(--radius-sm)',
        marginBottom: 'var(--space-4)',
        fontSize: 'var(--text-sm)',
      }}
    >
      {children}
    </div>
  );
}
